// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dynamic-faq-item[data-v-108bd3f4]{background-color:#f7f7f7}.dynamic-faq-item[data-v-108bd3f4] .object-cover{-o-object-fit:cover!important;object-fit:cover!important}.dynamic-faq-item a span[data-v-108bd3f4]{color:#262626;color:var(--color-neutral-800,#262626);font-family:Open Sans;font-size:16px;font-style:normal;font-weight:400;line-height:24px;-webkit-text-decoration-line:underline;text-decoration-line:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
